import { getDocs, orderBy, query } from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { CashWithdrawalCategory } from "./cash-withdrawal-category.entity";

class CashWithdrawalCategoryRepository extends RepositoryFirebase<CashWithdrawalCategory> {
  static readonly instance = new CashWithdrawalCategoryRepository();

  protected collection = "cash-withdrawal-categories";
  protected entity = CashWithdrawalCategory;

  async listAll(): Promise<CashWithdrawalCategory[]> {
    const ref = this.getCollection();
    const q = query(ref, orderBy("title", "asc"));
    const snap = await getDocs(q);
    return Promise.all(
      snap.docs.map((d) => CashWithdrawalCategory.build(d.id, d.data() as Record<string, unknown>))
    );
  }
}

export const cashWithdrawalCategoryRepository = CashWithdrawalCategoryRepository.instance;
